module.exports = __webpack_public_path__ + "static/media/yen-sign.4a35056f.svg";